export const COOKIES_KEY = {
  LOGIN_TOKEN: 'token',
  LOGIN_NAME: 'nickName',
  LOGIN_TYPE: 'accountType',
  RETURN_URL: 'returnUrl',
};
